import 'css-chunk:../components/utility.module.scss';export default {
  "absolute": "_absolute_5q5d7_1",
  "align_baseline": "_align_baseline_5q5d7_5",
  "align_center": "_align_center_5q5d7_9",
  "align_flex_start": "_align_flex_start_5q5d7_13",
  "animation_delay_5s": "_animation_delay_5s_5q5d7_17",
  "animation_duration_normal": "_animation_duration_normal_5q5d7_21",
  "animation_fill_forwards": "_animation_fill_forwards_5q5d7_25",
  "bg_dgrey3": "_bg_dgrey3_5q5d7_29",
  "big": "_big_5q5d7_33",
  "bigger": "_bigger_5q5d7_37",
  "block": "_block_5q5d7_41",
  "bold": "_bold_5q5d7_45",
  "center": "_center_5q5d7_49",
  "circular": "_circular_5q5d7_53",
  "color_inherit": "_color_inherit_5q5d7_57",
  "cursor_auto": "_cursor_auto_5q5d7_61",
  "direction_column": "_direction_column_5q5d7_65",
  "faded": "_faded_5q5d7_69",
  "fixed": "_fixed_5q5d7_73",
  "flex": "_flex_5q5d7_77",
  "flexible": "_flexible_5q5d7_81",
  "fs_reset": "_fs_reset_5q5d7_85",
  "gap_1": "_gap_1_5q5d7_89",
  "gap_2": "_gap_2_5q5d7_93",
  "gap_3": "_gap_3_5q5d7_97",
  "grab": "_grab_5q5d7_101",
  "h_100": "_h_100_5q5d7_105",
  "h_inherit": "_h_inherit_5q5d7_109",
  "hidden": "_hidden_5q5d7_113",
  "huge": "_huge_5q5d7_117",
  "important_opaque": "_important_opaque_5q5d7_121",
  "important_scaled_down": "_important_scaled_down_5q5d7_125",
  "invisible": "_invisible_5q5d7_129",
  "justify_center": "_justify_center_5q5d7_133",
  "left": "_left_5q5d7_137",
  "light": "_light_5q5d7_141",
  "m_auto": "_m_auto_5q5d7_145",
  "m_none": "_m_none_5q5d7_149",
  "no_background": "_no_background_5q5d7_153",
  "no_break_word": "_no_break_word_5q5d7_157",
  "normal_weight": "_normal_weight_5q5d7_161",
  "opaque": "_opaque_5q5d7_165",
  "overflow": "_overflow_5q5d7_169",
  "p_2": "_p_2_5q5d7_173",
  "p_3": "_p_3_5q5d7_177",
  "p_5": "_p_5_5q5d7_181",
  "pointer": "_pointer_5q5d7_185",
  "pointer_no": "_pointer_no_5q5d7_189",
  "pointer_yes": "_pointer_yes_5q5d7_193",
  "pt_3": "_pt_3_5q5d7_197",
  "relative": "_relative_5q5d7_201",
  "right": "_right_5q5d7_205",
  "round": "_round_5q5d7_209",
  "rounder": "_rounder_5q5d7_213",
  "scaled_down": "_scaled_down_5q5d7_217",
  "slightly_faded": "_slightly_faded_5q5d7_221",
  "small": "_small_5q5d7_225",
  "space_between": "_space_between_5q5d7_229",
  "space_evenly": "_space_evenly_5q5d7_233",
  "transform_center": "_transform_center_5q5d7_237",
  "underline": "_underline_5q5d7_241",
  "w_100": "_w_100_5q5d7_245",
  "wide": "_wide_5q5d7_249",
  "z_maximum": "_z_maximum_5q5d7_253",
  "white_bg_lgrey": "_white_bg_lgrey_5q5d7_257",
  "unstyled": "_unstyled_5q5d7_261",
  "unselectable": "_unselectable_5q5d7_267",
  "entire_screen": "_entire_screen_5q5d7_274",
  "no_interact": "_no_interact_5q5d7_281",
  "no_interact_with_children": "_no_interact_with_children_5q5d7_282",
  "do_interact": "_do_interact_5q5d7_288",
  "do_interact_with_children": "_do_interact_with_children_5q5d7_289",
  "color_brand": "_color_brand_5q5d7_295",
  "margin_gap_1": "_margin_gap_1_5q5d7_302",
  "margin_gap_2": "_margin_gap_2_5q5d7_306",
  "margin_gap_3": "_margin_gap_3_5q5d7_310",
  "margin_gap_5": "_margin_gap_5_5q5d7_314",
  "inline_margin_gap_2": "_inline_margin_gap_2_5q5d7_318",
  "animation_popin": "_animation_popin_5q5d7_322",
  "popin": "_popin_5q5d7_1"
};